import React from "react";
import { useNavigate } from "react-router-dom";
import emailIcon from "../../../Assets/Icons/emailIcon.svg";
import TextInput from "../../common/SignUp/TextInput";
import PrimaryButton from "../../common/PrimaryButton";
import FundraiserHeader from "../common/FundraiserHeader";
import { useFormik } from "formik";
import { forgetPasswordSchema } from "../../../utils/validationSchemas";
import { useDispatch, useSelector } from "react-redux";
import { setForgetPasswordData } from "../../../redux/slices/authSlice";
import { forgetPassword } from "../../../services/authService";
import Loader from "../../common/Loader";
import SwoodleFooter from "../../common/SwoodleFooter";

const responsiveShellStyle = {
  width: "100%",
  maxWidth: "min(1920px, calc(100vw - 2vw))",
  margin: "0 auto",
};

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authLoading = useSelector((state) => state.authReducer.loading);

  const navigation = () => {
    setTimeout(() => {
      navigate("/user-otpVerification");
    }, 1000);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgetPasswordSchema,
    onSubmit: async (values, { setFieldError }) => {
      try {
        const forgetPromise = await dispatch(
          forgetPassword({ email: values.email })
        ).unwrap();
        
        if (forgetPromise?.success === true) {
          dispatch(setForgetPasswordData({ email: values.email }));
          navigation();
        }
      } catch (error) {
        console.error("Forget password error:", error);
        // Display "Incorrect Email" below the field if the API call fails
        setFieldError("email", "Incorrect Email");
      }
    },
  });

  const { email } = formik.values;

  const { handleChange, handleBlur, handleSubmit, errors, touched } = formik;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <FundraiserHeader />

      <div className="flex-1 flex flex-col items-center px-4 pt-16 md:pt-24">
        <form className="w-full max-w-[500px]" onSubmit={handleSubmit}>
          {authLoading ? <Loader /> : null}

          {/* Heading Section */}
          <div className="text-center mb-10">
            <h1 className="text-[28px] md:text-[32px] font-[700] font-poppins text-[#303030] mb-3">
              Recover Account
            </h1>
            <p className="text-[14px] md:text-[16px] font-[400] font-poppins text-[#8C8C8C] leading-relaxed max-w-[400px] mx-auto">
              Please enter your email address. You will receive a link to create a new password via email
            </p>
          </div>

          <div className="space-y-6">
            <div className="flex flex-col">
              <label 
                htmlFor="email" 
                className="text-[14px] font-[700] font-poppins text-[#303030] mb-2"
              >
                Email address
              </label>
              <TextInput
                Icon={emailIcon}
                name={"email"}
                id="email"
                value={email}
                placeholder={"john.smith@gmail.com"}
                inputClass={"bg-transparent h-full placeholder:text-[#BDBDBD] outline-none"}
                iconAreaClass={"mr-3 opacity-80"}
                innerDivClass={"h-[56px] bg-[#F2F4F5] rounded-[8px] flex items-center px-4 border-none shadow-none focus-within:ring-1 focus-within:ring-[#00ADEF] transition-all"}
                inputDivClass={"mb-0"}
                handleChange={handleChange}
                handleBlur={handleBlur}
                error={errors.email}
                touched={touched.email}
              />
            </div>

            <PrimaryButton
              type="submit"
              className="w-full h-[56px] text-[18px] font-[600] rounded-[8px] mt-4"
              label="Recover"
              loading={authLoading}
            />
          </div>
        </form>
      </div>

      {/* Footer */}
      <div className="mt-16">
        <SwoodleFooter containerStyle={responsiveShellStyle} enableEntranceAnimation={true} />
      </div>
    </div>
  );
};

export default ForgetPassword;
